import { LanguageCode } from '__generated__/globalTypes';
import langUtils, { TYPE_WRITING_METHODS } from 'containers/language/utils';
import React, { useCallback } from 'react';
import Typewriter from 'typewriter-effect';
import constant from 'utils/constant';

interface ITypeWriterCustom {
    content: string;
    language?: LanguageCode | null;
    callBack?: (e: string) => void;
    name?: string;
    extraData?: any;
    setExtraData?: (e: any) => void;
}

const typeWriterOptions = {
    delay: constant.TYPE_WRITER_DELAY,
    cursor: '',
};

function TypeWriterCustom(props: ITypeWriterCustom) {
    const { content, callBack, name, extraData, setExtraData, language } = props;

    const stringSplitter = useCallback((text) => {
        const words = text.split(/(\s+)/);
        return words;
    }, []);

    const handleCallBack = () => {
        if (extraData && setExtraData) {
            setExtraData(extraData);
        }
        if (callBack && name) {
            callBack(name);
        }
    };

    const stringSplitterTypeWriterOption = React.useMemo(
        () => ({
            ...typeWriterOptions,
            stringSplitter,
        }),
        [stringSplitter],
    );

    if (langUtils.getTypeWritingMethod(language) === TYPE_WRITING_METHODS.CHAR) {
        return (
            <Typewriter
                onInit={(typewriter) => {
                    typewriter
                        .typeString(content)
                        .callFunction(() => {
                            handleCallBack();
                        })
                        .start();
                }}
                options={typeWriterOptions}
            />
        );
    }

    return (
        <Typewriter
            onInit={(typewriter) => {
                typewriter
                    .typeString(content)
                    .callFunction(() => {
                        handleCallBack();
                    })
                    .start();
            }}
            options={stringSplitterTypeWriterOption}
        />
    );
}

export default React.memo(TypeWriterCustom);
